module.exports = __webpack_public_path__ + "static/media/mySvgThree.7fc1f325.svg";